var KlaviyoSubscribe = KlaviyoSubscribe || {};
!function () {
  if (!KlaviyoSubscribe._loaded) {
    KlaviyoSubscribe._loaded = !0;
    var e = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    KlaviyoSubscribe._debug = -1 < document.location.hash.indexOf("#test"), KlaviyoSubscribe.has_called_bootstrap = !1, KlaviyoSubscribe.is_requirements_loaded = !1, KlaviyoSubscribe.bootstrap_queue = [], KlaviyoSubscribe.bootstrap_attempts = 0, KlaviyoSubscribe.instances = {}, KlaviyoSubscribe.isDebugMode = function () {
      return KlaviyoSubscribe._debug
    }, KlaviyoSubscribe.bootstrap = function (e) {
      KlaviyoSubscribe.has_called_bootstrap || (KlaviyoSubscribe.has_called_bootstrap = !0, KlaviyoSubscribe.fetchRequirements(e))
    }, KlaviyoSubscribe.loadScript = function (e, i, a) {
      var r = document.getElementsByTagName("head")[0], o = document.createElement("script");
      o.type = "text/javascript", o.src = e, r.appendChild(o), KlaviyoSubscribe.log("Loaded JS", e), KlaviyoSubscribe.whenTrue(i, a)
    }, KlaviyoSubscribe.injectCSS = function (e) {
      var i = document.getElementsByTagName("head")[0], a = document.createElement("style");
      a.type = "text/css", a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e)), i.appendChild(a)
    }, KlaviyoSubscribe.whenTrue = function (e, i) {
      var a = 0, r = function () {
        e() ? i() : 100 > ++a && setTimeout(r, 200)
      };
      r()
    }, KlaviyoSubscribe.loadJQuery = function (e) {
      KlaviyoSubscribe.loadScript("//cdnjs.cloudflare.com/ajax/libs/jquery/1.10.2/jquery.min.js", function () {
        return !!window.jQuery
      }, e)
    }, KlaviyoSubscribe.loadJQueryForm = function (e) {
      KlaviyoSubscribe.loadScript("//cdnjs.cloudflare.com/ajax/libs/jquery.form/3.32/jquery.form.min.js", function () {
        return !!window.jQuery && jQuery.fn.ajaxForm && jQuery.fn.formSerialize
      }, e)
    }, KlaviyoSubscribe.fetchRequirements = function (e) {
      if (document.getElementsByTagName("head"), e = e || {}, window.jQuery) jQuery.fn.ajaxForm ? KlaviyoSubscribe.processQueue() : KlaviyoSubscribe.loadJQueryForm(KlaviyoSubscribe.processQueue); else {
        var i = function () {
          KlaviyoSubscribe.log("jQuery loaded."), KlaviyoSubscribe.loadJQueryForm(KlaviyoSubscribe.processQueue)
        };
        !0 === e.assume_jquery ? KlaviyoSubscribe.whenTrue(function () {
          return !!window.jQuery
        }, i) : KlaviyoSubscribe.loadJQuery(i)
      }
    }, KlaviyoSubscribe.processQueue = function () {
      var e, i = function () {
        for (KlaviyoSubscribe.log("Processing queue."); e = KlaviyoSubscribe.bootstrap_queue.shift();) e();
        KlaviyoSubscribe.bootstrap_queue.push = function (e) {
          e()
        }
      };
      KlaviyoSubscribe.log("Waiting for DOM to process queue."), jQuery(i), setTimeout(i, 5e3)
    }, KlaviyoSubscribe.executeWhenRequirementsLoaded = function (e) {
      KlaviyoSubscribe.bootstrap_queue.push(e)
    }, KlaviyoSubscribe.watchField = function (i, a, r) {
      (r = r || {}).type = r.type || "text", "email" !== a && "$email" !== a || (r.type = "email"), KlaviyoSubscribe.bootstrap(), KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
        KlaviyoSubscribe.log("Watching field", i, jQuery(i).length);
        var o = function (i) {
          if (i = jQuery.trim($(i.target).val()), KlaviyoSubscribe.log("Watch field value", i), "email" !== r.type || e.test(i)) {
            if (window._learnq && _learnq.push) {
              var o = {};
              o[a] = i, _learnq.push(["identify", o])
            }
            r.callback && r.callback(a, i)
          }
        };
        r.delegate ? jQuery(r.delegate).on("change blur", i, o) : jQuery(i).on("change blur", o)
      })
    }, KlaviyoSubscribe.watchFormSubmission = function (e, i) {
      (i = i || {}).properties = i.properties || {}, i.list && (KlaviyoSubscribe.bootstrap(), KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
        if (i.properties) {
          var a = [];
          jQuery.each(i.properties, function (e, i) {
            a.push(e)
          }), a.length && (i.properties.$fields = a.join(","))
        }
        KlaviyoSubscribe.log("Watching form", e, jQuery(e).length);
        var r = function (e) {
          var a = $(e.target);
          if (window._learnq && _learnq.identify) {
            var r = _learnq.identify();
            if (r && (r = r.$email || r.email)) {
              if (i.if) {
                var o = jQuery(i.if);
                if (!o.length || (o.is(":checkbox") ? !o.is(":checked") : !o.val())) return void KlaviyoSubscribe.log("Subscribe if fails", o)
              }
              r = jQuery.extend({
                g: i.list,
                email: r
              }, i.properties), KlaviyoSubscribe.log("Subscribing", r), $.post("//manage.kmail-lists.com/ajax/subscriptions/subscribe", r), KlaviyoSubscribe._logMetric("submitModal", i.list), i.wait_seconds && (e.preventDefault(), setTimeout(function () {
                KlaviyoSubscribe.log("Submitting form", a), a.get(0).submit()
              }, 1e3 * i.wait_seconds))
            }
          }
        };
        i.delegate ? jQuery(i.delegate).on("submit", e, r) : jQuery(e).on("submit", r)
      }))
    }, KlaviyoSubscribe.attachToForms = function (e, i) {
      var a = (i = i || {}).extra_properties || {};
      a.$source = a.$source || "$embed", KlaviyoSubscribe.bootstrap(), KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
        KlaviyoSubscribe.log("Attaching to forms", e, jQuery(e).length), jQuery(e).each(function () {
          var e = jQuery(this), r = e.data("ajax-submit");
          r || (r = "//manage.kmail-lists.com/ajax/subscriptions/subscribe"), e.ajaxForm({
            url: r,
            type: "POST",
            beforeSubmit: function (i, r, o) {
              e.find('[type="submit"]').addClass('is-loading');
              try {
                if (!KlaviyoSubscribe.isFormValid(e)) return !1
              } catch (i) {
                setTimeout(function() {
                  e.find('.error_message').removeClass('active');
                  e.find('input[type="email"]').removeClass("input--error");
                },4000);
                return KlaviyoSubscribe.log(i), e.find('[type="submit"]').removeClass('is-loading'), e.find('input[type="email"]').addClass("input--error"), e.find(".error_message").addClass('active'), e.trigger("klaviyo.subscribe.error"), !1
              }
              KlaviyoSubscribe.log("$source", a.$source), KlaviyoSubscribe.normalizeFormFields(i, e, a, o), KlaviyoSubscribe._logMetric("submitModal", i.find(function (e) {
                return "g" === e.name
              }).value), e.find(".klaviyo_submit_button").attr("disabled", !0)
            },
            success: function (a, r, o) {
              e.find('[type="submit"]').removeClass('is-loading'), e.find(".success_message, .error_message").removeClass('active'), e.find(".klaviyo_submit_button").attr("disabled", !1), a.success ? (KlaviyoSubscribe.setClosedModalCookie(), (r = e.find(".success_message").addClass("active")).length || (r = e.parent().find(".success_message").addClass("active")), window._learnq && _learnq.push && (o = e.find('[name="email"]').val()) && (_learnq.push(["identify", {$email: o}]), _learnq.push(["trackActivity"])), i.success_url ? window.location = i.success_url : (!0 !== i.custom_success_message && r.html(i.success_message || '<div class="klaviyo_header">Thanks for subscribing!</div><div class="klaviyo_subheader">Check your email for a confirmation message.</div>').end(), !0 === i.hide_form_on_success && (e.find(".klaviyo_field_group input, .klaviyo_field_group button, .klaviyo_form_actions").removeClass('active'), e.is(".klaviyo_horizontal_form") && e.find(".klaviyo_field_group").removeClass('active')), i.success && i.success(e, a.data), e.trigger("klaviyo.subscribe.success").resetForm())) : (KlaviyoSubscribe.log(a.errors), e.find(".error_message").addClass("active").html(a.errors.join(" ")), e.trigger("klaviyo.subscribe.error"))
            }
          }), KlaviyoSubscribe.log("Attached to form", this)
        })
      })
    }, KlaviyoSubscribe.isFormValid = function (e) {
      var i = e.find('[name*="email"]').val();
      if (!i || !/@/.test(i)) throw KlaviyoSubscribe.log("Invalid email address"), "Invalid email address";
      return e.find('input[required="true"], select[required="true"]').each(function (i, a) {
        if ((a = jQuery(a)).is(":radio") || a.is(":checked")) {
          if (has_value = !!e.find('[name="' + a.attr("name") + '"]:checked').length, !has_value) throw KlaviyoSubscribe.log("Required field missing", a.attr("name")), "Required field missing: " + a.attr("name");
          return has_value
        }
        if (!a.val()) throw KlaviyoSubscribe.log("Required field missing", a.attr("name")), "Required field missing: " + a.attr("name")
      }), e.find(".select-date-widget").each(function (e, i) {
        i = jQuery(i);
        var a = KlaviyoSubscribe._int(i.find('[name$="_day"]').val()),
          r = KlaviyoSubscribe._int(i.find('[name$="_month"]').val()),
          o = KlaviyoSubscribe._int(i.find('[name$="_year"]').val());
        if (!(isNaN(a) || isNaN(r) || isNaN(o))) {
          switch (r) {
            case 1:
            case 3:
            case 5:
            case 7:
            case 8:
            case 10:
            case 12:
              if (1 <= a && 31 >= a) return;
            case 4:
            case 6:
            case 9:
            case 11:
              if (1 <= a && 30 >= a) return;
            case 2:
              if (1 <= a && a <= (o % 4 ? 28 : 29)) return
          }
          throw KlaviyoSubscribe.log("Invalid date", o, r, a), "Invalid date"
        }
      }), !0
    }, KlaviyoSubscribe.normalizeFormFields = function (e, i, a, r) {
      e.push({name: "$timezone_offset", type: "text", value: this._getUtcOffset()});
      var o, t = [];
      jQuery.each(a, function (i, a) {
        e.push({name: i, type: "text", value: a}), t.push(i)
      }), t.length && (jQuery.each(e, function (e, i) {
        if ("$fields" === i.name) return o = i, !1
      }), o ? o.value += "," + t.join() : e.push({
        name: "$fields",
        type: "text",
        value: t.join()
      })), i.find(".select-date-widget").each(function (i, a) {
        var r = (a = jQuery(a)).find('[name$="_day"]'), o = a.find('[name$="_month"]'), t = a.find('[name$="_year"]'),
          s = r.attr("name"), u = o.attr("name"), n = t.attr("name");
        r = KlaviyoSubscribe._int(r.val()), o = KlaviyoSubscribe._int(o.val()), t = KlaviyoSubscribe._int(t.val());
        if (!(isNaN(r) || isNaN(o) || isNaN(t))) {
          for (i = 0; i < e.length;) {
            var l = e[i];
            !l || l.name !== s && l.name !== u && l.name !== n ? i++ : e.splice(i, 1)
          }
          e.push({
            name: s.replace("_day", ""),
            required: !0,
            type: "text",
            value: KlaviyoSubscribe._formatDate(t, o, r)
          })
        }
      })
    }, KlaviyoSubscribe._getUtcOffset = function () {
      return (new Date).getTimezoneOffset() / -60
    }, KlaviyoSubscribe.setClosedModalCookie = function () {
      KlaviyoSubscribe._setCookie("klaClosedPopup", "1", 31536e6)
    }, KlaviyoSubscribe._setCookie = function (e, i, a) {
      a = new Date((new Date).getTime() + a), document.cookie = e + "=" + i + ";expires=" + a.toGMTString() + ";path=/"
    }, KlaviyoSubscribe._int = function (e) {
      return parseInt(e, 10)
    }, KlaviyoSubscribe._formatDate = function (e, i, a) {
      return 1 === a.toString().length && (a = "0" + a), 1 === i.toString().length && (i = "0" + i), e + "-" + i + "-" + a
    }, KlaviyoSubscribe.log = function () {
    }, KlaviyoSubscribe._logMetric = function (e, i) {
    }, Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
      value: function (e, i) {
        if (null == this) throw new TypeError('"this" is null or not defined');
        var a = Object(this), r = a.length >>> 0;
        if ("function" != typeof e) throw new TypeError("predicate must be a function");
        for (var o = 0; o < r;) {
          var t = a[o];
          if (e.call(i, t, o, a)) return t;
          o++
        }
      }
    })
  }
}();